import { graphql } from "react-relay";

export const eventSummaryAutopilotFragments = {
  org: graphql`
    fragment EventSummaryAutopilot_org on Org {
      id
      experiments
    }
  `,
  event: graphql`
    fragment EventSummaryAutopilot_event on Event
    @argumentDefinitions(calendarId: { type: "String!" }) {
      autopilotEventStatus(calendarId: $calendarId) {
        __typename
        ... on AutopilotEventStatus {
          status
        }
      }
      annotatedEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
          }
        }
      }
      annotatedRecurringEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
          }
        }
      }

      featureStatesForOrganizer {
        __typename
        ... on FeatureStates {
          freePaidFeatures {
            autopilotWhenOrganizerCurrentlyAllowed
            moveRangesEnabled
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};
